import { registerClient } from "./agent-api";
import { firebaseConfig } from "./config";
import { getApp, getApps, initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from "firebase/messaging";

export const setupFirebaseMessaging = async (refreshSensors) => {
    const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

    if (!('serviceWorker' in navigator) || !('Notification' in window)) {
        return;
    }

    const messaging = getMessaging(app);
    const serviceWorkerRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', { type: 'module' });
    const permission = await Notification.requestPermission();

    if (permission !== 'granted') {
        return;
    }

    const token = await getToken(messaging, {
        vapidKey: "BJh6qgRwaxOW3Vt-1QmgyFNKUedagBDGaoFFtMMINXQo7bxyUGHcOD0O-6o4qqmuG3mJK-UVdEOQlIqvWYhzskA",
        serviceWorkerRegistration
    });

    if (token) {
        registerClient(token);
    }

    onMessage(messaging, function (payload) {
        refreshSensors();
    });
};
